// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"091d8801","488":"6d304a8b"}[chunkId] + ".chunk.js";
};